import { ConfigOption } from "@kre-form/core";
import {
  KreFormFieldIonText,
  KreFormFieldIonTextArea,
  KreFormFieldIonNumber,
  KreFormFieldIonRadio,
  KreFormFieldIonRadioGroup,
  KreFormFieldIonCheckbox,
  KreFormFieldIonCheckboxGroup,
  KreFormFieldIonImage,
  KreFormFieldIonDatetime,
  KreFormFieldIonTextI18n,
  KreFormFieldIonSelect,
  KreFormFieldIonLine,
  KreFormFieldIonPassword,
  KreFormFieldIonHtml,
  KreFormFieldIonTable,
  KreFormFieldIonEditor,
  KreFormFieldIonSwitch,
} from "./types/types";
import { KreFormWrapperFormField } from "./wrappers/wrappers";
import { KreFormFieldGroup } from "./templates/group";
import { KreFormFieldRepeat } from "./templates/repeat";
import { KreFormFieldOverTime } from "./templates/overtime";
import { KreFormFieldEmployee } from "./templates/employee";
import { KreFormFieldPanel } from "./templates/panel";
import { KreFormFieldTabular } from "./templates/tabular";
import { KreFormFieldTabularItem } from "./templates/tabular-item";

export const FIELD_TYPE_COMPONENTS = [
  KreFormFieldIonText,
  KreFormFieldIonTextArea,
  KreFormFieldIonNumber,
  KreFormFieldIonRadio,
  KreFormFieldIonRadioGroup,
  KreFormFieldIonCheckbox,
  KreFormFieldIonCheckboxGroup,
  KreFormFieldIonImage,
  KreFormFieldIonDatetime,
  KreFormFieldIonTextI18n,
  KreFormFieldIonSwitch,
  KreFormFieldIonSelect,
  KreFormFieldIonLine,
  KreFormFieldIonPassword,
  KreFormFieldIonHtml,
  KreFormFieldIonTable,
  KreFormFieldIonEditor,

  // wrappers
  KreFormWrapperFormField,

  //templates
  KreFormFieldGroup,
  KreFormFieldRepeat,
  KreFormFieldOverTime,
  KreFormFieldEmployee,
  KreFormFieldPanel,
  KreFormFieldTabular,
  KreFormFieldTabularItem,
];

export const IONIC_KreFORM_CONFIG: ConfigOption = {
  types: [
    {
      name: "text",
      component: KreFormFieldIonText,
      wrappers: ["ion-field"],
    },
    {
      name: "texti18n",
      component: KreFormFieldIonTextI18n,
      wrappers: ["ion-field"],
    },
    {
      name: "textarea",
      component: KreFormFieldIonTextArea,
      wrappers: ["ion-field"],
    },
    {
      name: "numbers",
      component: KreFormFieldIonNumber,
      wrappers: ["ion-field"],
    },
    {
      name: "switch",
      component: KreFormFieldIonSwitch,
      wrappers: ["ion-field"],
    },
    {
      name: "radio",
      component: KreFormFieldIonRadio,
      wrappers: ["ion-field"],
    },
    {
      name: "radiogroup",
      component: KreFormFieldIonRadioGroup,
      wrappers: ["ion-field"],
    },
    {
      name: "checkbox",
      component: KreFormFieldIonCheckbox,
      wrappers: ["ion-field"],
    },
    {
      name: "checkboxgroup",
      component: KreFormFieldIonCheckboxGroup,
      wrappers: ["ion-field"],
    },
    {
      name: "select",
      component: KreFormFieldIonSelect,
      wrappers: ["ion-field"],
    },
    {
      name: "datetime",
      component: KreFormFieldIonDatetime,
      wrappers: ["ion-field"],
    },
    {
      name: "image",
      component: KreFormFieldIonImage,
      wrappers: ["ion-field"],
    },
    // {
    //   name: "update",
    //   component: KreFormFieldIonImage,
    //   wrappers: ["ion-field"],
    // },
    {
      name: "htmlcontent",
      component: KreFormFieldIonHtml,
      wrappers: ["ion-field"],
    },
    {
      name: "line",
      component: KreFormFieldIonLine,
      wrappers: ["ion-field"],
    },
    {
      name: "password",
      component: KreFormFieldIonPassword,
      wrappers: ["ion-field"],
    },
    {
      name: "panel",
      component: KreFormFieldPanel,
      wrappers: ["ion-field"],
    },

    // {
    //   name: "table",
    //   component: KreFormFieldIonTable,
    //   wrappers: ["ion-field"],
    // },
    // {
    //   name: "editor",
    //   component: KreFormFieldIonEditor,
    //   wrappers: ["ion-field"],
    // },
    { name: "group", component: KreFormFieldGroup },
    { name: "repeat", component: KreFormFieldRepeat },
    // { name: "overTime", component: KreFormFieldOverTime },

    // { name: "tabular", component: KreFormFieldTabular },
    // { name: "tabularitem", component: KreFormFieldTabularItem },
  ],
  wrappers: [{ name: "ion-field", component: KreFormWrapperFormField }],
};
